import { motion } from "framer-motion";
import { LogoLarge } from "@/components/Logo";
import GoogleReviews from "@/components/GoogleReviews";
import { useLang } from "@/i18n";

export default function AboutUs() {
  const { t } = useLang();
  return (
    <section id="chi-siamo" data-testid="about-section" className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 lg:gap-24 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden rounded-3xl">
            <img
              src="https://images.unsplash.com/photo-1502364271109-0a9a75a2a9df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxqYXBhbmVzZSUyMGN1aXNpbmUlMjBjaGVmJTIwY29va2luZ3xlbnwwfHx8fDE3ODQwMzU2MTJ8MA&ixlib=rb-4.1.0&q=85"
              alt="Chef Drago Ramen"
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
          </div>
          <div className="hidden md:block absolute -bottom-8 -right-8 w-40 h-40 rounded-full overflow-hidden border-4 border-ink shadow-2xl bg-white">
            <LogoLarge size={148} />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-gold" />
            <span className="text-xs uppercase tracking-[0.32em] text-gold font-medium">{t("about_overline")}</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight" data-testid="about-title">
            {t("about_title_1")} <span className="italic font-light">{t("about_title_end")}</span>.
          </h2>

          <div className="mt-8 space-y-5 text-white/70 leading-relaxed text-base md:text-lg">
            <p>{t("about_body_1")}</p>
            <p>{t("about_body_2")}</p>
            <p>{t("about_body_3")}</p>
          </div>

          <GoogleReviews />
        </motion.div>
      </div>
    </section>
  );
}
